import typeTableMap from '@/resources/reservation/typeTableMap'
import { POST } from '@/api'

const initial = {
  name: '',
  tableIds: [],
  tableType: 1,
  tableTypeLabel: null,
  privRoomType: 0,
  seatJoinFlg: false,
  smokingType: 0,
}

export default {
  namespaced: true,
  state: {
    syncGnavi: initial,
    busy: false,
  },
  getters: {
    matchedTables(state, getters, rootState, { 'tables/all': tables }) {
      const { tableIds } = state.syncGnavi
      if (!tableIds.length) return tables
      const selected = tables.find(table => tableIds.includes(table.id))
      return tables.filter(
        table =>
          table.minAvailableSeat === selected.minAvailableSeat && table.maxAvailableSeat === selected.maxAvailableSeat,
      )
    },
  },
  mutations: {
    clear(state) {
      state.syncGnavi = initial
    },
    update(state, detail) {
      state.syncGnavi = { ...state.syncGnavi, ...detail }
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async get(store, id) {
      const { commit } = store
      commit('busy', true)
      commit('clear')

      const { status, message, data } = await POST('/api/web/sync_gnavi/detail', { id })

      if (status === 200) {
        const syncGnavi = data.syncGnavi
        commit('update', syncGnavi)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)

      return status === 200
    },
    hasOtherTypeName({ state: { syncGnavi }, rootGetters: { 'tables/all': tables } }) {
      const regexOtherTypeName = new RegExp(
        `.*(${Object.keys(typeTableMap)
          .filter(type => +type && +type !== syncGnavi.tableType)
          .map(type => typeTableMap[type])
          .join('|')}).*`,
      )
      return tables.some(table => syncGnavi.tableIds.includes(table.id) && regexOtherTypeName.test(table.name))
    },
    async save(store) {
      const {
        commit,
        state,
        rootGetters: { 'tables/all': tables },
      } = store

      if (state.busy) return false

      commit('busy', true)

      const selected = tables.find(table => table.id === state.syncGnavi.tableIds[0])
      const { status, message } = await POST('/api/web/sync_gnavi/regist', {
        ...state.syncGnavi,
        tableTypeLabel: state.syncGnavi.tableType === 99 ? state.syncGnavi.tableTypeLabel : null,
        minAvailableSeat: selected.minAvailableSeat,
        maxAvailableSeat: selected.maxAvailableSeat,
        smokingType: state.syncGnavi.smokingType,
      })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)

      return status === 200
    },
  },
}
